import $ from "jquery";
import Ajax from "base/Ajax";
import Page from "webPage/Page";
import {svg_include} from "./index";

export default class DealerResources {

    constructor($element) {
        this.$element = $element;

        this.$downloads_area = this.$element.find('.js-resource-files');

        this.$mainFilters = this.$element.find('.js-main-filters');
        this.$topFilters = this.$element.find('.js-top-filters');

        this.$search = this.$element.find('.js-search-input');

        this.request = null;

        this.filters = {};

        this.bindEvents();

        this.updateLatestFilters();
    }

    bindEvents() {
        let me = this;

        this.$element.on('click', '.js-toggle-filter-accordion', function () {
            $(this).closest('.js-accordion').toggleClass('filters__accordion--open');
            return false;
        }).on('click', '.js-show-filters', function () {
            $('body').addClass('show-filters');
            return false;
        }).on('click', '.js-hide-filters', function () {
            $('body').removeClass('show-filters');
            return false;
        }).on('change', '.js-update-filters', () => {
            if ($(window).outerWidth() >= DealerResources.SIDEBAR_SIZE) {
                me.updateLatestFilters();
                me.getDownloads(true);
            }
        }).on('click', '.js-change-page', function () {
            me.filters.page = parseInt($(this).attr('data-page'));
            me.getDownloads(true);

            return false;
        }).on('click', '.js-save-filters', () => {
            this.updateLatestFilters();
            this.getDownloads(true);
            $('body').removeClass('show-filters');
            return false;
        }).on('click', '.js-cancel-filters', () => {
            console.log('7');
            this.updateFilters();
            $('body').removeClass('show-filters');
            return false;
        }).on('click', '.js-clear-section', function () {
            let section = $(this).closest('.js-accordion').attr('data-name');
            me.clearFilterSection(section);
            me.updateLatestFilters();
            me.getDownloads(true);
            return false;
        }).on('click', '.js-clear-all', () => {
            this.$search.val('');
            this.clearFilters();
            this.updateLatestFilters();
            this.getDownloads(true);
            return false;
        }).on('change', '.js-all', function () {
            let section = $(this).closest('.js-accordion').attr('data-name');
            me.clearFilterSection(section);
            me.updateLatestFilters();
            me.getDownloads(true);
            return false;
        }).on('click', '.js-retry', () => {
            me.getDownloads(true);
            return false;
        }).on('click', '.js-show-results-search', function () {
            me.updateLatestFilters();
            me.getDownloads(true);
            return false;
        });

        this.$mainFilters.on('submit', function () {
            console.log('13');

            me.updateLatestFilters();
            me.getDownloads(true);
            return false;
        });

        window.onpopstate = function (event) {
            let filters = {};

            let regexp = new RegExp('/dealer-resources/([^/]+)/((?!page)[^/]+)/?');
            let pattern = regexp.exec(window.location.pathname);

            if (pattern !== null) {
                if ('undefined' !== typeof pattern[2] && pattern[2] !== 'all') {
                    filters.category = [pattern[2]];
                }
            }

            let pageRegexp = new RegExp('^.*/page/([0-9]+)/?');
            let pagePattern = pageRegexp.exec(window.location.pathname);

            if (pagePattern !== null && 'undefined' !== typeof pagePattern[1]) {
                filters.page = pagePattern[1];
            }

            let queryString = Page.get_query();

            me.filters = $.extend(true, {}, filters, queryString);

            me.updateFilters();
            me.getDownloads(false);
        }
    }

    updateFilters() {
        this.clearFilters();

        Object.keys(this.filters).forEach((key) => {
            if ('undefined' !== typeof key) {
                let value = this.filters[key];
                if (Array.isArray(value)) {
                    value.forEach((filter) => {
                        this.$mainFilters.find('input[type="checkbox"][name="' + key + '[]"][value="' + filter + '"]').prop('checked', true);
                        this.$topFilters.find('input[type="checkbox"][name="' + key + '[]"][value="' + filter + '"]').prop('checked', true);
                    });
                } else {
                    this.$mainFilters.find('input[type="checkbox"][name="' + key + '"][value="' + value + '"]').prop('checked', true);
                    this.$topFilters.find('input[type="checkbox"][name="' + key + '"][value="' + value + '"]').prop('checked', true);

                    this.$mainFilters.find('select[name="' + key + '"]').val(value);
                    this.$topFilters.find('select[name="' + key + '"]').val(value);
                }
            }
        });

        this.$search.val(this.filters.search);

        this.updateClearButtons();
    }

    clearFilters() {
        this.$mainFilters.find('input[type="checkbox"]').prop('checked', false);
        this.$mainFilters.find('select').val('');

        this.$topFilters.find('input[type="checkbox"]').prop('checked', false);
        this.$topFilters.find('select:not([name="limit"])').val('');
    }

    clearFilterSection(section) {
        this.$mainFilters.find('.js-accordion[data-name="' + section + '"]').find('input[type="checkbox"]').prop('checked', false);
        this.$mainFilters.find('.js-accordion[data-name="' + section + '"]').find('select').val('');

        this.$topFilters.find('.js-accordion[data-name="' + section + '"]').find('input[type="checkbox"]').prop('checked', false);
        this.$topFilters.find('.js-accordion[data-name="' + section + '"]').find('select').val('');
    }

    updateLatestFilters() {
        let main_filters = this.$mainFilters.serializeJSON();

        delete main_filters["all-button"];

        if ($(window).outerWidth() < DealerResources.SIDEBAR_SIZE) {
            this.filters = main_filters;
        } else {
            let top_filters = this.$topFilters.serializeJSON();

            let top_filter_values = ["latest_version_only", "limit"];

            // Replace the values of filters from the top
            for (let key of top_filter_values) {
                main_filters[key] = top_filters[key];
            }

            this.filters = main_filters;
            this.filters.page = 1;
        }

        this.filters.search = this.$search.val();

        let title = 'All';
        if ('undefined' !== typeof this.filters['dlm_download_category'] && this.filters['dlm_download_category'].length === 1) {
            if (this.filters['dlm_download_category'][0] === 'scales') {
                title = 'Scales';
            } else if (this.filters['dlm_download_category'][0] === 'store-management-software') {
                title = 'Store Management Software';
            }
        }

        this.$element.find('.js-title').text(title);

        this.updateClearButtons();
    }

    updateClearButtons() {
        let filters = $.extend({}, this.filters);

        delete filters.page;
        delete filters['limit'];
        delete filters['latest_version_only'];

        this.$mainFilters.find('.filters__heading--selected').removeClass('filters__heading--selected');
        this.$mainFilters.find('.js-all').prop('checked', true);


        if (Object.keys(filters).length > 0) {
            this.$mainFilters.find('.js-filter-heading-main').addClass('filters__heading--selected');
        }

        Object.keys(filters).forEach((filter) => {
            this.$mainFilters.find('.js-accordion[data-name="' + filter + '"] .js-all').prop('checked', false);
        });

    }

    getDownloads(pushState) {
        this.$downloads_area.addClass('loading');

        if (this.request !== null) {
            this.request.abort();
        }

        this.request = Ajax.get('avery-berkel/v1', 'downloads/get', this.filters);
        this.updateFilters();

        this.request.then((data) => {
            this.request = null;
            this.$downloads_area.removeClass('loading');

            if ('undefined' !== typeof data.headers) {
                delete data.headers;
            }

            this.updateDownloads(data);
        }).catch((e) => {
            console.log(e);
            this.request = null;
            this.showErrorMessage();
            this.$downloads_area.removeClass('loading');
        });

        if (pushState) {
            history.pushState({}, '', this.fullPageUrl());
        }
    }

    updateDownloads(data) {

        if ('undefined' !== typeof data.downloads && data.downloads.length > 0) {

            this.$downloads_area.html('');

            data.downloads.forEach((download) => {
                this.$downloads_area.append(this.buildDownload(download));
            });

            this.$downloads_area.append(this.buildPagination(data, 2, ''));
            this.updateTopPagination(data);

        } else {
            this.showNoDownloadsMessage();
            this.updateTopPagination(data);
        }
    }

    buildDownload(downloads) {
        let download = 'undefined' === typeof downloads.parent.post ? null : downloads.parent.post;
        let version = 'undefined' === typeof downloads.version ? null : downloads.version;
        let documentType = 'undefined' === typeof downloads.documentType ? null : downloads.documentType;

        const hasVersion = version !== null && version.version !== null && version.version.trim() !== '';
        const hasVersionDate = version !== null && version.dateAdded !== null && version.dateAdded.trim() !== '';

        let icon = version.fileType === '' ? 'none' : version.fileType;

        if (['pdf'].indexOf(icon) === -1) {
            icon = 'none';
        }

        return (eotwJSXFactory('div', {className: "dealer-resource"}, [
            eotwJSXFactory('div', {className: "dealer-resource__type"}, [
                eotwJSXFactory('div', {className: "dealer-resource__icon", unsafeHtml: (svg_include('resource-icon--' + icon))}),
                eotwJSXFactory('div', {className: "dealer-resource__size"}, ['undefined' === typeof version ? '' : version.fileSize])
            ]),
            eotwJSXFactory('div', {className: "dealer-resource__information"}, [
                eotwJSXFactory('div', {className: "dealer-resource__title"}, [
                    eotwJSXFactory('h2', {className: "heading heading--4"}, ['undefined' === typeof download['post_title'] ? '' : download['post_title']])
                ]),
                eotwJSXFactory('div', {className: "dealer-resource__meta"}, [
                    !hasVersionDate ? '' : (eotwJSXFactory('div', {className: "dealer-resource__meta-item"}, ["Added on ", version.dateAdded])),
                    (documentType === null) ? '' : (eotwJSXFactory('div', {className: "dealer-resource__meta-item"}, ['undefined' !== typeof documentType.name ? documentType.name : ''])),
                    !hasVersion ? '' : (eotwJSXFactory('div', {className: "dealer-resource__meta-item"}, ["V", version.version]))
                ])
            ]),
            eotwJSXFactory('div', {className: "dealer-resource__download"}, [
                eotwJSXFactory('a', {href: downloads.link, className: "read-more-link read-more-link--download"}, ["Download", eotwJSXFactory('span', {className: "read-more-link__icon", unsafeHtml: (svg_include('download-icon'))})])
            ])
        ]));
    }

    showNoDownloadsMessage() {
        this.$downloads_area.html(eotwJSXFactory('div', {className: "no-results"}, [
            eotwJSXFactory('div', {className: "no-results__icon", unsafeHtml: (svg_include('circle-icon--no-results'))}),
            eotwJSXFactory('h2', {className: "heading heading--3"}, ["No Results"]),
            eotwJSXFactory('p', null, ["There are no resources that match your current filters."])
        ]));
    }

    showErrorMessage() {
        this.$downloads_area.html(eotwJSXFactory('div', {className: "no-results"}, [
            eotwJSXFactory('div', {className: "no-results__icon", unsafeHtml: (svg_include('circle-icon--no-results'))}),
            eotwJSXFactory('h2', {className: "heading heading--3"}, ["Could not retrieve downloads"]),
            eotwJSXFactory('p', null, ["An error occurred when trying to retrieve the downloads, please try again. If this problem persists please contact us."]),
            eotwJSXFactory('button', {class: "read-more-link js-retry"}, ["Try Again ", eotwJSXFactory('span', {class: "read-more-link__icon", unsafeHtml: (svg_include('navigation-arrow'))})])
        ]));
    }

    fullPageUrl() {
        let base = this.pageUrl();

        let page = '';

        if ('undefined' !== typeof this.filters.page && this.filters.page > 1) {
            page = 'page/' + this.filters.page;
        }

        let queryString = this.pageQueryString(base);

        return base + page + queryString;
    }

    pageUrl() {
        let parts = [];

        if ('undefined' !== typeof this.filters['dlm_download_category']) {
            if (this.filters['dlm_download_category'].length > 1) {
                parts.push('all');
            } else {
                parts.push(this.filters['dlm_download_category'][0]);
            }
        } else {
            parts.push('all');
        }

        if ('undefined' !== typeof this.filters['product_series']) {
            if (this.filters['product_series'].length > 1) {
                parts.push('all');
            } else {
                parts.push(this.filters['product_series'][0]);
            }
        } else {
            parts.push('all');
        }

        return '/dealer-resources/' + parts.join('/') + '/';
    }

    pageQueryString(base) {
        let queryString = '';
        let filters = Object.assign({}, this.filters);

        delete filters.page;
        delete filters['dlm_download_category'];
        delete filters.user;
        delete filters._wpnonce;

        let sector = '';
        if ('undefined' !== typeof base) {
            let parts = base.replace(/^\/+|\/+$/g, '').split('/');

            if ('undefined' !== typeof parts[1]) {
                sector = parts[1];
            }
        }


        if ('undefined' !== typeof filters['product_series']) {
            if (filters['product_series'].length <= 1) {
                delete filters['product_series'];
            }
        }

        if (Object.keys(filters).length > 0) {
            queryString += "?" + $.param(filters).replace(/%5B%5D/g, "[]");
        }

        return queryString;
    }

    getPageLink(base, i) {
        let link = base;

        if (i > 1) {
            link += 'page/' + i + '/';
        }

        link += this.pageQueryString(link);

        return link;
    }

    updateTopPagination(data) {

        let $topPagination = this.$topFilters.find('.js-top-pagination');

        if (data['total_pages'] === 0) {
            $topPagination.html('');
        } else {
            $topPagination.html(this.buildPagination(data, 1, 'pagination--box'));
        }
    }

    buildPagination(data, pagination_range, extraClass) {
        if (data['total_pages'] <= 1) {
            return;
        }

        let total_pages = parseInt(data['total_pages']);
        let page = parseInt(data['current_page']);
        let range = pagination_range !== null ? pagination_range : 2;
        let show_items = (range * 2) + 1;

        let base = this.pageUrl();

        let $pagination = (eotwJSXFactory('section', {className: "pagination " + extraClass}));

        let $wrap = (eotwJSXFactory('div', {className: "pagination__wrap js-wrap"}));

        if (page > 1) {
            $wrap.append(eotwJSXFactory('a', {href: this.getPageLink(base, page - 1) + this.pageQueryString(base), 'data-page': page - 1, className: "pagination__direction-link js-change-page"}, [
                eotwJSXFactory('span', {className: "pagination__direction-link-icon", unsafeHtml: (svg_include('breadcrumb-arrow'))}),
                eotwJSXFactory('span', {className: "pagination__direction-link-text"}, ["Previous"])
            ]));
        }

        let $list = (eotwJSXFactory('ol', {className: "pagination__list"}));

        for (let i = 1; i <= total_pages; i++) {
            if (1 !== total_pages && (!(i >= page + range + 1 || i <= page - range - 1) || total_pages <= show_items)) {
                $list.append(eotwJSXFactory('li', {className: "pagination__item"}, [
                    page === i ? (eotwJSXFactory('span', {className: "pagination__link pagination__link--active"}, [i])) : (eotwJSXFactory('a', {href: this.getPageLink(base, i) + this.pageQueryString(base), 'data-page': i, className: "pagination__link js-change-page"}, [i]))
                ]),);
            }
        }

        $wrap.append($list);

        if (page < total_pages) {
            $wrap.append(eotwJSXFactory('a', {href: this.getPageLink(base, page + 1) + this.pageQueryString(base), 'data-page': page + 1, className: "pagination__direction-link pagination__direction-link--next js-change-page"}, [
                eotwJSXFactory('span', {className: "pagination__direction-link-text"}, ["Next"]),
                eotwJSXFactory('span', {className: "pagination__direction-link-icon", unsafeHtml: (svg_include('breadcrumb-arrow'))})
            ]));
        }

        $pagination.append($wrap);
        return $pagination;
    }
}

DealerResources.SIDEBAR_SIZE = 960;